<template>
  <div v-loading="loading">
    <el-form :model="formData" ref="formData" :rules="rulesAdd" label-width="120px" label-position="right" size="small"
             style="margin-right: 3vw">
      <el-row>
        <el-col :span="24">
          <el-form-item label="标题：" prop="about_name" label-width="120px" style="height: 50%">
            <el-input v-model="formData.about_name"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="排序：" prop="sort" label-width="120px" style="height: 50%">
            <el-input-number v-model="formData.sort" controls-position="right" :min="0" :max="100000000" ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="发生时间：" prop="about_time" label-width="120px" style="height: 50%">
            <el-date-picker v-model="formData.about_time"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            format="yyyy-MM-dd HH:mm:ss"
                            placeholder="发生时间">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row >
        <el-col :span="24">
          <el-form-item label="封面图片：" label-width="120px">
            <AttachmentUpload
                ref="fileUpload"
                :isShow="true"
                :objectID="formData.id"
                :UseType="1"
                :TableName="uploadForm.tableName"
                @input="getAttachList"
                :multiple="false"
                :MaxFileNum="1"
                :fileType="['jpeg', 'bmp','jpg','png','gif']"
            ></AttachmentUpload>
            <AttachmentList
                ref="fileList"
                :objectID="formData.id"
                :UseType="1"
                :TableName="uploadForm.tableName"
                :ShowDelete="true"
                @AttachmentList="haveUploadedFiles"
            ></AttachmentList>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div style="text-align:center;">
      <el-button type="primary" @click="addOrUpdate" size="small">保存</el-button>
    </div>
  </div>
</template>
<script>
import AttachmentList from "@/components/AttachmentList";
import AttachmentUpload from "../../components/AttachmentUpload";

export default {
  name: "ResponsibilityEdit",
  props: ["data", "title"],
  components: { AttachmentList, AttachmentUpload},
  data() {
    return {
      formData: this.data,
      rulesAdd: {
        about_name: [{required: true, message: "必填项", trigger: "blur"}],
      },
      loading: false,
      fileID: this.data.id,
      uploadForm: {
        tableName: "t_about_main",
        state: false,//上传状态
      },
    }
  },
  methods: {
    addOrUpdate() {
      let that = this;
      this.$refs.formData.validate((valid) => {
        if (valid) {
          that.$api.post("/SocialResponsibility/saveData", that.formData,
              function (res) {
                if (res.code === "200" && res.msg === "true") {
                  that.$emit("closeModal");
                  that.$message.success("保存成功");
                } else {
                  that.$message.warning("保存失败");
                }
              }
          );
        } else {
          return false;
        }
      });
    },
    afterload() {
      this.loading = false;
    },
    getAttachList() {
      this.$refs.fileList.GetAttachmentList();
    },
    haveUploadedFiles(resData) {
      if (resData[0] && resData[0].ObjectID) {
        this.uploadForm.state = true;
      } else {
        this.uploadForm.state = false;
      }
    },
    change(val) {
      var that = this;
      that.formData.about_content = val;
    },
  },
  mounted() {
  },
  created() {
  },
  watch: {
    data: function () {
      this.formData = this.data;
    },
  }
}
</script>
<style scoped lang="less">

</style>
